<template>
    <el-popover popper-class="el-popper--mixmapstyle " placement="top"
        ref="altitudePopover" trigger="click" :append-to-body="!isFullScreen">
        <div class="map-bottomtool__items">
            <div class="map-bottomtool__item" :class="{
                'is-active': flyType === 'dangerPoint',
            }" @click="handleEmergencyButtonClick('dangerPoint')">
                <div class="map-bottomtool__item-img img-danger"></div>
                <div class="map-bottomtool__item-title">
                    {{ mixin_hasI18n ? $t('map.bottomTool.markAccidentPoint') : "标记事发点" }}
                </div>
            </div>
            <div class="map-bottomtool__item" :class="{
                'is-active': flyType === 'firePoint',
            }" @click="handleEmergencyButtonClick('firePoint')">
                <div class="map-bottomtool__item-img img-fire"></div>
                <div class="map-bottomtool__item-title">
                    {{ mixin_hasI18n ? $t('map.bottomTool.markCombustionPoint') : "标记燃烧点" }}
                </div>
            </div>
            <div class="map-bottomtool__item" :class="{
                'is-active': flyType === 'wind',
            }" @click="handleEmergencyButtonClick('wind')">
                <div class="map-bottomtool__item-img img-wind"></div>
                <div class="map-bottomtool__item-title">
                    {{ mixin_hasI18n ? $t('map.bottomTool.markWindDirection') : "标记风向" }}
                </div>
            </div>
            <div class="map-bottomtool__item" :class="{
                'is-active': flyType === 'warningLine-1',
            }" @click="handleEmergencyButtonClick('warningLine-1')">
                <div class="map-bottomtool__item-img img-warning-1"></div>
                <div class="map-bottomtool__item-title">
                    {{ mixin_hasI18n ? $t('map.bottomTool.markFirstLevelWarningLine') : "标记一级警戒线" }}
                </div>
            </div>
            <div class="map-bottomtool__item" :class="{
                'is-active': flyType === 'warningLine-2',
            }" @click="handleEmergencyButtonClick('warningLine-2')">
                <div class="map-bottomtool__item-img img-warning-2"></div>
                <div class="map-bottomtool__item-title">
                    {{ mixin_hasI18n ? $t('map.bottomTool.markSecondLevelWarningLine') : "标记二级警戒线" }}
                </div>
            </div>
            <div class="map-bottomtool__item" :class="{
                'is-active': flyType === 'warningLine-3',
            }" @click="handleEmergencyButtonClick('warningLine-3')">
                <div class="map-bottomtool__item-img img-warning-3"></div>
                <div class="map-bottomtool__item-title">
                    {{ mixin_hasI18n ? $t('map.bottomTool.markThirdLevelWarningLine') : "标记三级警戒线" }}
                </div>
            </div>
        </div>
        <div :class="['map-bottomtool__btn', { 'is-first': isFirst, 'is-last': isLast }]" slot="reference">
            <Icon-svg class="map-bottomtool__btn-icon" :name="'fullscreen_line'" />
            {{ mixin_hasI18n ? $t('map.bottomTool.realTimeCommand') : "实时指挥" }}
        </div>
    </el-popover>
</template>

<script>
import i18nMixn from '../../../../components/map/mixins/i18n-mixin';
import FullScreenUtil from '@/utils/fullscreen';

export default {
    mixins: [i18nMixn],
    props: {
        modelValue: {
            type: String,
            default: '',
        },
        isFirst: {
            type: Boolean,
            default: false,
        },
        isLast: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            isFullScreen: false,
        };
    },
    computed: {
        flyType: {
            get () {
                return this.modelValue;
            },
        },
    },
    methods: {
        handleEmergencyButtonClick (type) {
            this.$emit('update:modelValue', type);
            this.$emit('emergencyClick', type);
            if (this.$refs.altitudePopover) {
                this.$refs.altitudePopover.doClose();
            }
        },
    },
    mounted () {
        const self = this;
        this.removeFullScreenListener = FullScreenUtil.onFullScreenChange((isFull) => {
            self.isFullScreen = isFull;
        });
    },
    beforeDestroy () {
        if (typeof this.removeFullScreenListener === 'function' && this.removeFullScreenListener !== null) {
            this.removeFullScreenListener();
        }
    },
};
</script>

<style lang="scss" scoped>
.map-bottomtool {
    &__items {
        width: 160px;
    }

    &__item {
        padding-bottom: 10px;
        text-align: center;
        cursor: pointer;
        display: flex;
        color: white;
        align-items: center;

        &:nth-last-child(1) {
            padding-bottom: 0;
        }

        &.is-disable {
            color: hsla(0, 0%, 100%, 0.6) !important;
            cursor: not-allowed !important;
        }

        &.is-active {
            background-color: rgba(32, 129, 251, 0.5);
        }

        &-img {
            width: 24px;
            height: 24px;
            text-align: center;
            vertical-align: middle;
            background-size: 100% 100%;
            background-repeat: no-repeat;

            &.img-danger {
                background-image: url("~@/assets/images/bottomtool/icon-danger.png") !important;
            }

            &.img-fire {
                background-image: url("~@/assets/images/bottomtool/icon-fire.png") !important;
            }

            &.img-wind {
                background-image: url("~@/assets/images/bottomtool/icon-wind-1.png") !important;
            }

            &.img-warning-1 {
                background-image: url("~@/assets/images/bottomtool/icon-warning-1.png") !important;
            }

            &.img-warning-2 {
                background-image: url("~@/assets/images/bottomtool/icon-warning-2.png") !important;
            }

            &.img-warning-3 {
                background-image: url("~@/assets/images/bottomtool/icon-warning-3.png") !important;
            }
        }

        &-title {
            flex: 1;
        }
    }

    &__btn {
        display: inline-block;
        width: 92px;
        height: 27px;
        line-height: 27px;
        font-size: 14px;
        color: white;
        text-align: center;
        position: relative;
        cursor: pointer;
        margin-left: 8px;
        z-index: 0;

        &::before {
            content: '';
            display: block;
            position: absolute;
            width: calc(100% - 40px);
            height: 100%;
            top: 0px;
            left: 0px;
            z-index: -1;
            border: 1px solid transparent;
            border-right-width: 0px;
            border-radius: 3px 0px 0px 3px;
            background: linear-gradient(180deg, hsl(238, 91%, 13%) 0%, hsl(238, 91%, 13%) 100%) center center no-repeat content-box,
                linear-gradient(180deg, hsl(183, 100%, 66%) 0%, hsl(183, 100%, 66%) 100%) top left no-repeat border-box,
                linear-gradient(180deg, hsl(183, 100%, 66%) 0%, hsl(183, 100%, 66%) 100%) bottom left no-repeat border-box,
                linear-gradient(180deg, hsl(220, 73%, 37%) 0%, hsl(220, 73%, 37%) 100%) center center no-repeat border-box;
            background-size: 100%, 8px 8px, 8px 8px, 100%;
        }

        &::after {
            content: '';
            display: block;
            position: absolute;
            width: calc(100% - 40px);
            height: 100%;
            top: 0px;
            left: 40px;
            z-index: -1;
            border: 1px solid transparent;
            border-left-width: 0px;
            border-radius: 0px 3px 3px 0px;
            background: linear-gradient(180deg, hsl(238, 91%, 13%) 0%, hsl(238, 91%, 13%) 100%) center center no-repeat content-box,
                linear-gradient(180deg, hsl(183, 100%, 66%) 0%, hsl(183, 100%, 66%) 100%) top right no-repeat border-box,
                linear-gradient(180deg, hsl(183, 100%, 66%) 0%, hsl(183, 100%, 66%) 100%) bottom right no-repeat border-box,
                linear-gradient(180deg, hsl(220, 73%, 37%) 0%, hsl(220, 73%, 37%) 100%) center center no-repeat border-box;
            background-size: 100%, 8px 8px, 8px 8px, 100%;
        }

        &.is-first {
        }

        &.is-last {
            &::after {
                transform: skew(30deg);
            }
        }

        &.is-active,
        &:hover {
            &::before {
                background: linear-gradient(180deg, #2f6bef 0%, #2f6bef 100%) center center no-repeat content-box,
                    linear-gradient(180deg, hsl(183, 100%, 66%) 0%, hsl(183, 100%, 66%) 100%) top left no-repeat border-box,
                    linear-gradient(180deg, hsl(183, 100%, 66%) 0%, hsl(183, 100%, 66%) 100%) bottom left no-repeat border-box,
                    linear-gradient(180deg, hsl(220, 73%, 37%) 0%, hsl(220, 73%, 37%) 100%) center center no-repeat border-box;
                background-size: 100%, 8px 8px, 8px 8px, 100%;
            }

            &::after {
                background: linear-gradient(180deg, #2f6bef 0%, #2f6bef 100%) center center no-repeat content-box,
                    linear-gradient(180deg, hsl(183, 100%, 66%) 0%, hsl(183, 100%, 66%) 100%) top right no-repeat border-box,
                    linear-gradient(180deg, hsl(183, 100%, 66%) 0%, hsl(183, 100%, 66%) 100%) bottom right no-repeat border-box,
                    linear-gradient(180deg, hsl(220, 73%, 37%) 0%, hsl(220, 73%, 37%) 100%) center center no-repeat border-box;
                background-size: 100%, 8px 8px, 8px 8px, 100%;
            }
        }
    }

    &__btn-icon {
        height: 18px;
        width: 18px;
        line-height: 18px;
        display: inline-block;
        vertical-align: middle;
    }
}
</style>
